<div class="row contact contact--form">
  @if (!unauthorized) {
    <div class="col-12 offset-lg-2 col-lg-8 contact__intro">
      <h3 *appApplyIfNotEmpty="translationService.getTranslation('contact_intro')"
          [innerHTML]="translationService.getTranslation('contact_intro')"
          class="contact__intro-title"></h3>
    </div>
  }

  @if (send) {
    <div class="contact contact--sent" [innerHTML]="'WTF' + translationService.getTranslation('contact_send')"></div>
  } @else {
    <div class="col-12 {{ unauthorized ? '' : 'offset-lg-2 col-lg-8' }} contact__description">
      <p [innerHTML]="translationService.getTranslation('contact_description')"
          class="contact__description-title"></p>
    </div>
    <div class="col-12 {{ unauthorized ? '' : 'offset-lg-2 col-lg-8' }}">
      <app-general-errors [errors]="errorsArr" class="contact__errors"></app-general-errors>
      <mat-card class="mat-mdc-card-outlined mt-2 contact__card" style="{{ unauthorized ? 'margin: 0 -16px; border: 1px solid transparent !important;' : '' }}">
        <mat-card-content class="contact__card-content">
          <form [formGroup]="contactForm" class="contact__form">
            <div class="row contact__form-row">
              <mat-form-field class="col-12 contact__form-field contact__form-field--type">
                <mat-label [innerHTML]="translationService.getTranslation('contact_type')"
                           class="contact__label contact__label--type"></mat-label>
                <mat-select formControlName="reason" required aria-required="true" data-cy="select-contact-type"
                            class="contact__select contact__select--type">
                  @for (contactType of contactTypes; track contactType) {
                    <mat-option
                      [value]="contactType.key" data-cy="option-contact-type"
                      class="contact__option contact__option--type">{{ contactType.description }}
                    </mat-option>
                  }
                </mat-select>
                @if (contactForm.get('reason').hasError('message')) {
                  <mat-error
                    class="contact__error contact__error--type">{{ contactForm.get('reason').getError('message') }}
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field class="col-12 contact__form-field contact__form-field--message">
                <mat-label
                  class="contact__label contact__label--message">{{ translationService.getTranslation('contact_message') }}
                </mat-label>
                <textarea maxLength="65535" matInput cdkAutosizeMinRows="5" cdkTextareaAutosize formControlName="memo"
                          required
                          #memo data-cy="input-contact-message"
                          class="contact__textarea contact__textarea--message"></textarea>
                @if (memo === document?.activeElement && memo.value.length >= 1) {
                  <mat-hint align="end" class="contact__hint contact__hint--message">{{ memo.value.length }}
                    / {{ memo.maxLength }}
                  </mat-hint>
                }
                @if (contactForm.get('memo').hasError('message')) {
                  <mat-error
                    class="contact__error contact__error--message">{{ contactForm.get('memo').getError('message') }}
                  </mat-error>
                }
              </mat-form-field>
              @if (isSaving) {
                <div style="text-align: center;" class="contact__saving">
                  <app-loading-spinner class="contact__spinner"></app-loading-spinner>
                </div>
              }
              <div class="col-12 contact__form-actions">
                <button [hidden]="isSaving" mat-raised-button color="primary" data-cy="btn-send"
                        [disabled]="contactForm.invalid ||
                                  !(
                                    !unauthorized ||
                                    (userBackendId !== undefined && userBackendId > 0) ||
                                    (isValidEmail(this.emailAddress) === 'valid' && addressForm.valid)
                                  )"
                        (click)="onSendContact()"
                        class="contact__button contact__button--send">
                  {{ translationService.getTranslation('button_send') }}
                </button>
              </div>
            </div>
          </form>
        </mat-card-content>
      </mat-card>
    </div>
  }
</div>
